import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CroppedMockup } from '../CroppedMockup';
import { volumes } from '../../data/volumes';
export function VolumesSection() {
  return <section className="bg-ink-soft px-5 py-20 md:py-28" data-id="element-217" data-mp="2mudjmgl0g651">
      <div className="mx-auto max-w-6xl" data-id="element-218" data-mp="2rtgpg38tege2">
        <SectionHeading title="3 volúmenes. Un solo método." subtitle="Cada volumen cumple una función y se conecta con el siguiente." data-id="element-219" data-mp="2rsf2p1ifs5gi" />

        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-220" data-mp="2itbj7wfcxo1h">
          {volumes.map(v => <article key={v.tag} className="flex flex-col rounded-3xl border border-gold/30 bg-ink p-6" data-id="element-221" data-mp="2iveh12mr4lgr">
              <CroppedMockup crop={v.crop} alt={`Portada: ${v.title}`} className="mx-auto w-full max-w-[200px]" data-id="element-222" data-mp="242b1t1wmujt7" />
              <p className="mt-6 self-start rounded-full bg-gold px-3 py-1 font-display text-xs font-extrabold uppercase tracking-widest text-black" data-id="element-223" data-mp="1v3pi33ffcyqu">
                {v.tag}
              </p>
              <h3 className="mt-4 font-display text-xl font-black uppercase leading-tight text-cream md:text-2xl" data-id="element-224" data-mp="1z75dxxjo6v2h">{v.title}</h3>
              <p className="mt-3 text-lg text-neutral-400" data-id="element-225" data-mp="1akozk3hhahos">{v.headline}</p>
              <ul className="mt-5 space-y-2.5" data-id="element-226" data-mp="1phg04g2w1zfz">
                {v.list.map(item => <li key={item} className="flex items-center gap-2.5 text-base text-cream md:text-lg" data-id="element-227" data-mp="1pgofu1eqro50">
                    <CheckIcon className="h-4 w-4 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-228" data-mp="1kj4u6gfps931" />
                    {item}
                  </li>)}
              </ul>
              <p className="mt-auto pt-6" data-id="element-229" data-mp="rv0i9d6juzrw">
                <span className="block border-t border-gold/25 pt-4 font-display text-xs font-extrabold uppercase tracking-wide text-gold md:text-sm" data-id="element-230" data-mp="rruwo7x4qg0x">
                  {v.flow.join(' → ')}
                </span>
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}